import { useState } from "react";
import {
  ButtonContantUs,
  ButtonLocalData,
  ButtonMainInfo,
  ButtonSecurity,
  ContainerButton,
  ContainerContactPage,
  ContainerContactUsPage,
  ContainerContantInfo,
  DescribeText,
  EmailSupport,
  HeaderContactUsPage,
  Languages,
  LogoBrand,
  SupportLangsInfo,
  TitleContact,
  TitleNameBrand,
  TitlePage,
  NameUser,
  NicNameUserColor,
  ButtonCredits,
} from "./ContactUsPageStyles.styled";
import { useLanguageContext } from "../../../Components/Languages/Langs/LanguageContext";
import { useLogoStudioHook } from "./PictureHook";
import useAuth from "../../../Redux/useAuth";
import { NavLink } from "react-router-dom";
import { ButtonBackPage } from "../SecurityPage/SecurityPageStyles.styled";
import { ButtonBackPageIcon } from "../../MainInfo/Icons/Icons";
import { ButtonLogOut } from "../../../Components/ModelWindows/Logout/LogOut.styled";
import { ModelWindow } from "../../../Components/ModelWindow/ModelWindow";
import { Logout } from "../../../Components/ModelWindows/Logout/Logout";

export const ContantUsPage = () => {
  const { user } = useAuth();
  const { t } = useLanguageContext();
  const logoStudio = useLogoStudioHook();

  const [openModelLogOut, setOpenModelLogOut] = useState(false);
  const [showLogOut, setShowLogOut] = useState(false);

  const openLogOut = () => {
    setShowLogOut(true);
    setTimeout(() => setOpenModelLogOut(true), 0);
  };

  const closeLogOut = () => {
    setOpenModelLogOut(false);
    setTimeout(() => setShowLogOut(false), 250);
  };
  return (
    <>
      <HeaderContactUsPage>
        <NavLink to={`/home-page/${user?.name?.toLowerCase()}}`}>
          <ButtonBackPage>
            <ButtonBackPageIcon />
          </ButtonBackPage>
        </NavLink>
        <NameUser>
          {t("privateTraslate.privateHeaderNameUser")}
          <NicNameUserColor> {user?.name || "User"}</NicNameUserColor>
        </NameUser>
        <TitlePage>{t("privateTraslate.contactUsPageTitle")}</TitlePage>
      </HeaderContactUsPage>

      <ContainerContactUsPage>
        <ContainerButton>
          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/main-info`}>
            <ButtonMainInfo>
              {t("privateTraslate.updateDataUserPageTitle")}
            </ButtonMainInfo>
          </NavLink>

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/security-page`}>
            <ButtonSecurity>
              {t("privateTraslate.securityPageTitle")}
            </ButtonSecurity>
          </NavLink>

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/languages`}>
            <Languages>{t("privateTraslate.languagesPageTitle")}</Languages>
          </NavLink>

          {/* <NavLink to={`/home-page/${user?.name?.toLowerCase()}/modes`}>
            <ButtonModes>{t("privateTraslate.ModesPage")}</ButtonModes>
          </NavLink> */}

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/local-data`}>
            <ButtonLocalData>
              {t("privateTraslate.LocalDataPage")}
            </ButtonLocalData>
          </NavLink>

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/contacts`}>
            <ButtonContantUs>
              {t("privateTraslate.contactUsPageTitle")}
            </ButtonContantUs>
          </NavLink>
          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/credits`}>
            <ButtonCredits>{t("privateTraslate.ButtonCredit")}</ButtonCredits>
          </NavLink>

          <ButtonLogOut onClick={openLogOut}>
            {t("privateTraslate.logOutButton")}
          </ButtonLogOut>
        </ContainerButton>

        <ContainerContactPage>
          <TitleContact>
            {t("privateTraslate.Contact-Us-Page.Title")}
          </TitleContact>
          <TitleNameBrand>
            {t("privateTraslate.Contact-Us-Page.NameStudio")}
          </TitleNameBrand>
          {logoStudio && <LogoBrand src={logoStudio} alt="logo-studio" />}
          <ContainerContantInfo>
            <DescribeText>
              {t("privateTraslate.Contact-Us-Page.OurContant")}
            </DescribeText>
            <EmailSupport href="mailto:support@safe-tasker.com">
              support@safe-tasker.com
            </EmailSupport>
            <SupportLangsInfo>
              {t("privateTraslate.Contact-Us-Page.SupportLangs")}
            </SupportLangsInfo>
          </ContainerContantInfo>
          {/* add p tag in letter should be age user */}
        </ContainerContactPage>
      </ContainerContactUsPage>

      {showLogOut && (
        <ModelWindow onClose={closeLogOut} isOpen={openModelLogOut}>
          <Logout onClose={closeLogOut} />
        </ModelWindow>
      )}
    </>
  );
};
